import type { Crumb } from '@/lib/structured-data';

export const AGENTS_PATH = '/agents';
export const STANDARDS_PATH = '/standards';
/** The signed-in rules library, where catalog agents are added. */
export const AGENTS_LIBRARY_PATH = '/agents-library';

/** Query param on the rules library that opens a catalog agent's add or enable dialog. */
export const ADD_CATALOG_AGENT_QUERY_PARAM = 'add';

/**
 * Query param on the rules library that opens a custom agent's edit dialog, by CustomRules ID or,
 * for an organization agent, by the agent's ID.
 */
export const EDIT_AGENT_QUERY_PARAM = 'edit';

export const AGENT_CATALOG_EVENTS = {
  ADD_CLICKED: 'agent_catalog_add_clicked',
  EXPORT_COPIED: 'agent_catalog_export_copied',
  LIBRARY_ADD_OPENED: 'agent_catalog_library_add_opened',
  PENDING_PROMPT_SHOWN: 'agent_catalog_pending_prompt_shown',
  PENDING_PROMPT_CLICKED: 'agent_catalog_pending_prompt_clicked',
} as const;

export const STANDARDS_CRUMB: Crumb = { name: 'Standards', path: STANDARDS_PATH };
export const AGENTS_CRUMB: Crumb = { name: 'Agents', path: AGENTS_PATH };

export function agentPath(slug: string): string {
  return `${AGENTS_PATH}/${slug}`;
}

/** Anchor for a category's section on the /agents index. */
export function agentCategoryAnchor(category: string): string {
  return category.toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

export function stackPath(slug: string): string {
  return `${STANDARDS_PATH}/${slug}`;
}

/** Rules library URL that opens this agent's dialog, after sign-in if needed. */
export function addCatalogAgentHref(slug: string): string {
  return `${AGENTS_LIBRARY_PATH}?${ADD_CATALOG_AGENT_QUERY_PARAM}=${encodeURIComponent(slug)}`;
}

/**
 * Rules library URL that opens an agent's edit dialog. `agentId` is a CustomRules ID or, for an
 * organization agent, the agent's ID.
 */
export function editAgentHref(agentId: string): string {
  return `${AGENTS_LIBRARY_PATH}?${EDIT_AGENT_QUERY_PARAM}=${encodeURIComponent(agentId)}`;
}
